export default {
	billings: {
		title: 'Bill management',
		bills: 'Bills',
		download_bill: 'Download selected bill',
		shop_name: 'Store name',
		billing_no: 'Number',
		billing_name: 'Name',
		billing_detail: 'Detail',
		price: 'Price',
		pay_method: 'Payment method',
		stauts: 'Status',
		down_success: 'Download success',
		card: 'Monthly virtual card',
		all_pay: 'All payment methods',
	},
}
